import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api, { setTokens, setUser } from '../api';
import './Auth.css';

export default function Register() {
  const [role, setRole] = useState('client'); // 'client' | 'partner'
  const [form, setForm] = useState({
    name: '', email: '', password: '',
    pet_name: '', pet_species: '', pet_birth_date: '',
    clinic_name: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [registered, setRegistered] = useState(false);
  const navigate = useNavigate();

  const update = (field) => (e) => setForm({ ...form, [field]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const payload = {
        name: form.name,
        email: form.email,
        password: form.password,
        role,
      };
      if (role === 'client') {
        payload.pet_name = form.pet_name;
        payload.pet_species = form.pet_species;
        payload.pet_birth_date = form.pet_birth_date;
      } else {
        payload.clinic_name = form.clinic_name;
      }
      await api.post('/auth/register', payload);
      setRegistered(true);
    } catch (err) {
      const msg = err.response?.data?.error?.message || 'Ошибка регистрации';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  if (registered) {
    return (
      <div className="auth-page">
        <div className="auth-card">
          <div className="auth-logo">✅</div>
          <h1>Регистрация успешна!</h1>
          <p className="auth-subtitle">
            {role === 'partner'
              ? 'Заявка принята. Мы свяжемся с вами и активируем доступ к чату.'
              : 'Ваш аккаунт ожидает активации администратором клиники. Мы уведомим вас, когда аккаунт будет активирован.'}
          </p>
          <div className="auth-link"><Link to="/login">Войти</Link></div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">🐾</div>
        <h1>VetChat</h1>
        <p className="auth-subtitle">Регистрация</p>

        <div className="auth-role-toggle" role="tablist">
          <button
            type="button"
            role="tab"
            aria-selected={role === 'client'}
            className={'auth-role-btn' + (role === 'client' ? ' active' : '')}
            onClick={() => setRole('client')}
          >
            Я клиент
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={role === 'partner'}
            className={'auth-role-btn' + (role === 'partner' ? ' active' : '')}
            onClick={() => setRole('partner')}
          >
            Я партнёр
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          {error && <div className="auth-error">{error}</div>}

          <div className="auth-field">
            <label>ФИО * {role === 'client' && (
              <span className="auth-hint">Укажите ваше реальное ФИО, для идентификации вашего питомца с документацией клиники</span>
            )}</label>
            <input value={form.name} onChange={update('name')} placeholder={role === 'partner' ? 'Иванов Иван Иванович' : 'Иванова Мария Сергеевна'} required autoFocus />
          </div>

          <div className="auth-field">
            <label>Email *</label>
            <input type="email" value={form.email} onChange={update('email')} placeholder="your@email.com" required />
          </div>

          <div className="auth-field">
            <label>Пароль *</label>
            <input type="password" value={form.password} onChange={update('password')} placeholder="Минимум 6 символов" required minLength={6} />
          </div>

          {role === 'client' ? (
            <>
              <div className="auth-divider">Ваш питомец</div>

              <div className="auth-field">
                <label>Кличка питомца</label>
                <input value={form.pet_name} onChange={update('pet_name')} placeholder="Мурка" />
              </div>

              <div className="auth-row">
                <div className="auth-field">
                  <label>Вид</label>
                  <select value={form.pet_species} onChange={update('pet_species')}>
                    <option value="">Выберите</option>
                    <option value="кот">Кот / Кошка</option>
                    <option value="собака">Собака</option>
                    <option value="попугай">Попугай</option>
                    <option value="хомяк">Хомяк</option>
                    <option value="кролик">Кролик</option>
                    <option value="другое">Другое</option>
                  </select>
                </div>
                <div className="auth-field">
                  <label>Дата рождения</label>
                  <input type="date" value={form.pet_birth_date} onChange={update('pet_birth_date')} />
                </div>
              </div>
            </>
          ) : (
            <div className="auth-field">
              <label>Название клиники <span className="auth-hint">Необязательно</span></label>
              <input value={form.clinic_name} onChange={update('clinic_name')} placeholder="Ветклиника «Барс»" />
            </div>
          )}

          <button type="submit" className="auth-btn" disabled={loading}>
            {loading ? 'Регистрация...' : 'Зарегистрироваться'}
          </button>
        </form>

        <p className="auth-link">
          Уже есть аккаунт? <Link to="/login">Войти</Link>
        </p>
      </div>
    </div>
  );
}
